import styled from 'styled-components'

export const StepContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`
